import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const env = createEnv({
  server: {
    HOST_BASE_URL: z.url().optional(),
    HOST_SECRET: z.string().min(1),
    API_BASE_URL: z.url().min(1),
    API_AUTH_TOKEN: z.string().min(1),
    API_LANGUAGE_CODE: z.string().min(1),
    SITEMAP_DATABASE_CONNECTION_STRING: z.string().min(1).optional(),
    SITEMAP_BASE_URL: z.url().optional(),
    GOOGLE_ANALYTICS_ID: z.string().min(1).optional(),
    VERCEL_ANALYTICS: z.stringbool().optional().default(false),
  },
  client: {
    NEXT_PUBLIC_API_BASE_URL: z.string().min(1),
  },
  experimental__runtimeEnv: {
    NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
  },
  skipValidation: !!process.env.SKIP_ENV_VALIDATION,
});
